/* =====================================================
   SoulsInClothes — theme.js
   Vanilla JS, feature-gated. Each module runs only if
   its target elements exist on the page.
   Ported from ~/Desktop/SOULS IN CLOTHES/homepage_prototype.html
   ===================================================== */

(function () {
  'use strict';

  var hasGSAP = typeof window.gsap !== 'undefined';
  if (hasGSAP && typeof window.ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ───────────────────────────────────────────────
     NAV — scroll state, logo toggle, mobile menu
     ─────────────────────────────────────────────── */
  (function initNav() {
    var nav = document.getElementById('mainNav');
    if (!nav) return;

    // Non-homepage: start in scrolled (opaque) state immediately
    var transparent = nav.dataset.transparent === 'true';
    if (!transparent) {
      nav.classList.add('scrolled');
    }

    function updateScrolled() {
      if (transparent) {
        nav.classList.toggle('scrolled', window.scrollY > 80);
      }
      // Non-transparent pages: always keep scrolled
    }

    if (hasGSAP && !reduceMotion && transparent) {
      ScrollTrigger.create({
        start: 'top -80',
        onUpdate: function (self) {
          nav.classList.toggle('scrolled', self.scroll() > 80);
        }
      });
    } else {
      window.addEventListener('scroll', updateScrolled, { passive: true });
    }

    // Logo: show SIC mark only when scrolled down
    var logo = document.getElementById('navLogo');
    if (logo) {
      function updateLogo() {
        if (window.scrollY > 200) {
          logo.classList.add('show-sic');
        } else {
          logo.classList.remove('show-sic');
        }
      }
      window.addEventListener('scroll', updateLogo, { passive: true });
      updateLogo();
    }

    // Mobile menu
    var mobileBtn = nav.querySelector('.nav-mobile-toggle');
    var mobileDrawer = document.getElementById('mobileMenu');
    var mobileClose = mobileDrawer && mobileDrawer.querySelector('.mobile-menu-close');

    function openMobile() {
      mobileDrawer.classList.add('open');
      mobileBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMobile() {
      mobileDrawer.classList.remove('open');
      mobileBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (mobileBtn && mobileDrawer) {
      mobileBtn.addEventListener('click', openMobile);
      if (mobileClose) mobileClose.addEventListener('click', closeMobile);
      mobileDrawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', closeMobile);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileDrawer.classList.contains('open')) closeMobile();
      });
    }
  })();

  /* ───────────────────────────────────────────────
     HERO — rotating tagline + entrance animation
     ─────────────────────────────────────────────── */
  (function initHero() {
    var heroSub = document.getElementById('heroSub');
    if (heroSub) {
      var sayings = [
        'Made by hand. Worn for decades. Never rushed.',
        'One garment. One maker. Made to fit your life.',
        'Sewn in Bulgaria. Sent free, anywhere in the world.',
        'Slow fashion for a fast world. Handmade since 2020.',
        'Dark silhouettes. Natural linen. Made to order.',
        'Made to the shape of you. Natural linen. Free shipping, everywhere.',
        'Top-rated seller. 4.8 stars. Loved in 40 countries.'
      ];
      heroSub.textContent = sayings[Math.floor(Math.random() * sayings.length)];
    }

    if (!document.getElementById('hero') || !hasGSAP || reduceMotion) return;
    var tl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 1.2 } });
    if (document.querySelector('.hero-text')) {
      tl.from('.hero-text', { x: -60, opacity: 0, delay: 0.3 });
    }
    // Hero image stays static — no intro animation
    if (document.querySelector('.hero-scroll')) {
      tl.from('.hero-scroll', { opacity: 0, y: 20, duration: 0.8 }, '-=0.4');
    }
  })();

  /* ───────────────────────────────────────────────
     MANIFESTO — word-by-word scrubbed reveal
     ─────────────────────────────────────────────── */
  (function initManifesto() {
    var manifesto = document.getElementById('manifesto');
    if (!manifesto || !hasGSAP || reduceMotion) return;
    if (window.innerWidth < 768) return; // scrub: 1.8 scroll-jacks the page on mobile

    function wrapWords(line) {
      // Unwrap a wrapping <p> tag (richtext fields add one automatically)
      if (line.children.length === 1 && line.firstElementChild.tagName === 'P') {
        var p = line.firstElementChild;
        while (p.firstChild) line.insertBefore(p.firstChild, p);
        line.removeChild(p);
      }
      var nodes = Array.from(line.childNodes);
      while (line.firstChild) line.removeChild(line.firstChild);
      nodes.forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (/\S/.test(part)) {
              var s = document.createElement('span');
              s.className = 'mword';
              s.style.cssText = 'display:inline-block;will-change:transform,opacity';
              s.textContent = part;
              line.appendChild(s);
            } else if (part) {
              line.appendChild(document.createTextNode(part));
            }
          });
        } else if (node.classList) {
          node.classList.add('mword');
          node.style.cssText += ';display:inline-block;will-change:transform,opacity';
          line.appendChild(node);
        }
      });
    }

    gsap.utils.toArray('#manifesto .manifesto-line').forEach(wrapWords);

    var mTl = gsap.timeline({
      scrollTrigger: {
        trigger: '#manifesto',
        start: 'top 75%',
        end: 'bottom 55%',
        scrub: 1.8
      }
    });
    gsap.utils.toArray('#manifesto .manifesto-line').forEach(function (line, i) {
      var words = line.querySelectorAll('.mword');
      mTl.from(words, {
        opacity: 0, y: 14, scale: 0.94,
        stagger: 0.04, ease: 'power2.out', duration: 0.25
      }, i * 0.28);
    });
  })();

  /* ───────────────────────────────────────────────
     COLLECTIONS — entrance + scroll whisper
     ─────────────────────────────────────────────── */
  (function initCollections() {
    if (!document.getElementById('collections') || !hasGSAP || reduceMotion) return;

    gsap.from('.collection-card', {
      opacity: 0, y: 24, scale: 0.96,
      stagger: 0.13, duration: 1, ease: 'power2.out',
      scrollTrigger: { trigger: '#collections', start: 'top 80%' }
    });

    ScrollTrigger.create({
      trigger: '#collections',
      start: 'top 65%',
      once: true,
      onEnter: function () {
        var wrap = document.getElementById('collections-scroll-wrap');
        if (!wrap) return;
        var tweens = [];
        var cancelled = false;

        function cancel() {
          if (cancelled) return;
          cancelled = true;
          tweens.forEach(function (t) { t.kill(); });
          wrap.removeEventListener('pointerdown', cancel);
          wrap.removeEventListener('wheel', cancel);
          wrap.removeEventListener('touchstart', cancel);
        }
        wrap.addEventListener('pointerdown', cancel, { once: true });
        wrap.addEventListener('wheel', cancel, { once: true });
        wrap.addEventListener('touchstart', cancel, { once: true, passive: true });

        wrap.scrollLeft = 55;
        tweens.push(gsap.to(wrap, {
          scrollLeft: 0, duration: 1.6, ease: 'power2.out', delay: 0.6,
          onComplete: function () {
            if (cancelled) return;
            tweens.push(gsap.to(wrap, {
              scrollLeft: 28, duration: 1.3, ease: 'power1.inOut', delay: 0.3,
              onComplete: function () {
                if (cancelled) return;
                tweens.push(gsap.to(wrap, { scrollLeft: 0, duration: 1.5, ease: 'power2.out', delay: 0.1 }));
              }
            }));
          }
        }));
      }
    });
  })();

  /* ───────────────────────────────────────────────
     REVIEWS — native scroll + progress dots
     ─────────────────────────────────────────────── */
  (function initReviews() {
    var track = document.getElementById('reviewsTrack');
    if (!track) return;
    var dots = document.querySelectorAll('.progress-dot');
    if (!dots.length) return;
    var cardW = 420 + 32;
    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / cardW);
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }, { passive: true });
  })();

  /* ───────────────────────────────────────────────
     BESTSELLER — slide-in halves
     ─────────────────────────────────────────────── */
  (function initBestseller() {
    if (!document.getElementById('bestseller') || !hasGSAP || reduceMotion) return;
    gsap.from('.bestseller-image', {
      x: -80, opacity: 0, duration: 1.1, ease: 'power3.out',
      scrollTrigger: { trigger: '#bestseller', start: 'top 70%', toggleActions: 'play none none none' }
    });
    gsap.from('.bestseller-content', {
      x: 80, opacity: 0, duration: 1.1, ease: 'power3.out',
      scrollTrigger: { trigger: '#bestseller', start: 'top 70%', toggleActions: 'play none none none' }
    });
  })();

  /* ───────────────────────────────────────────────
     PULL QUOTE — typewriter
     ─────────────────────────────────────────────── */
  (function initPullQuote() {
    var el = document.getElementById('pq-text');
    if (!el || !hasGSAP) return;
    var attr = document.querySelector('.pq-attr');
    var source = el.getAttribute('data-text') || el.textContent.trim();
    if (reduceMotion) {
      el.textContent = source;
      if (attr) attr.classList.add('visible');
      return;
    }
    el.textContent = '';
    var fired = false;

    ScrollTrigger.create({
      trigger: '#pull-quote',
      start: 'top 75%',
      once: true,
      onEnter: function () {
        if (fired) return; fired = true;
        var i = 0;
        var speed = 28;
        function type() {
          if (i <= source.length) {
            el.textContent = source.slice(0, i);
            i++;
            setTimeout(type, i < 10 ? speed * 3 : speed);
          } else if (attr) {
            attr.classList.add('visible');
          }
        }
        setTimeout(type, 400);
      }
    });
  })();

  /* ───────────────────────────────────────────────
     COMPARISON — row stagger
     ─────────────────────────────────────────────── */
  (function initComparison() {
    if (!document.getElementById('comparison') || !hasGSAP || reduceMotion) return;
    gsap.from('.comparison-table tbody tr', {
      opacity: 0, y: 14,
      duration: 0.45, ease: 'power2.out', stagger: 0.07,
      scrollTrigger: { trigger: '#comparison', start: 'top 72%', toggleActions: 'play none none none' }
    });
  })();

  /* ───────────────────────────────────────────────
     GENERIC REVEAL — GSAP if available, else IO
     ─────────────────────────────────────────────── */
  (function initReveal() {
    var els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    if (!els.length) return;
    if (reduceMotion) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (hasGSAP) {
      els.forEach(function (el) {
        ScrollTrigger.create({
          trigger: el, start: 'top 82%', once: true,
          onEnter: function () { el.classList.add('in'); }
        });
      });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -18% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
  })();

  /* ───────────────────────────────────────────────
     FAQ accordion
     ─────────────────────────────────────────────── */
  (function initFAQ() {
    var qs = document.querySelectorAll('.faq-question');
    if (!qs.length) return;
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentElement;
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
        q.setAttribute('aria-expanded', !wasOpen ? 'true' : 'false');
      });
    });
  })();

  /* ───────────────────────────────────────────────
     STYLED BY YOU — popup
     ─────────────────────────────────────────────── */
  (function initStyled() {
    var btns = document.querySelectorAll('.styled-plus');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var item = btn.closest('.styled-item');
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.styled-item').forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('.styled-item').forEach(function (i) { i.classList.remove('open'); });
    });
  })();

  /* ───────────────────────────────────────────────
     SIZE GUIDE — unit toggle tabs
     ─────────────────────────────────────────────── */
  (function initSizeTabs() {
    var tabs = document.querySelectorAll('.size-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        document.querySelectorAll('.size-table').forEach(function (t) { t.style.display = 'none'; });
        var measurePanel = document.getElementById('measure-panel');
        if (measurePanel) measurePanel.style.display = 'none';
        if (tab.id === 'measureBtn' && measurePanel) {
          measurePanel.style.display = 'block';
        } else if (tab.dataset.unit) {
          var table = document.getElementById('size-table-' + tab.dataset.unit);
          if (table) table.style.display = 'table';
        }
      });
    });
  })();

  /* ───────────────────────────────────────────────
     SEARCH OVERLAY — Shopify predictive search
     ─────────────────────────────────────────────── */
  (function initSearch() {
    var toggle = document.getElementById('searchToggle');
    var overlay = document.getElementById('searchOverlay');
    var input = document.getElementById('searchInput');
    var results = document.getElementById('searchResults');
    var closeBtn = document.getElementById('searchClose');
    if (!toggle || !overlay || !input || !results) return;

    function open() {
      overlay.style.display = 'block';
      setTimeout(function () { overlay.style.transform = 'translateY(0)'; }, 20);
      input.focus();
    }
    function close() {
      overlay.style.transform = 'translateY(-100%)';
      setTimeout(function () {
        overlay.style.display = 'none';
        input.value = '';
        results.textContent = '';
      }, 300);
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var debounceTimer;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (!q) { results.textContent = ''; return; }
      debounceTimer = setTimeout(function () { runSearch(q); }, 220);
    });

    function runSearch(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderResults(data, q); })
        .catch(function () {
          results.textContent = '';
          var msg = document.createElement('p');
          msg.style.cssText = 'font-family:Inter,sans-serif;font-size:13px;color:#9a8f85;padding:12px 0;';
          msg.textContent = 'Search unavailable. Try again.';
          results.appendChild(msg);
        });
    }

    function renderResults(data, q) {
      results.textContent = '';
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        var msg = document.createElement('p');
        msg.style.cssText = 'font-family:Inter,sans-serif;font-size:13px;color:#9a8f85;padding:12px 0;';
        msg.textContent = 'No results for "' + q + '"';
        results.appendChild(msg);
        return;
      }
      products.forEach(function (p) {
        var link = document.createElement('a');
        link.href = p.url;
        link.style.cssText = 'display:flex;align-items:center;gap:16px;padding:10px 0;border-bottom:1px solid rgba(28,28,28,0.06);text-decoration:none;';
        var thumb = document.createElement('div');
        thumb.style.cssText = 'width:48px;height:60px;background:#ede8df;flex-shrink:0;background-size:cover;background-position:center;';
        if (p.image) thumb.style.backgroundImage = 'url(' + p.image + ')';
        var info = document.createElement('div');
        var name = document.createElement('p');
        name.style.cssText = 'font-family:"Cormorant Garamond",Georgia,serif;font-size:17px;color:#1c1c1c;margin:0 0 2px;';
        name.textContent = p.title;
        var price = document.createElement('p');
        price.style.cssText = 'font-family:Inter,sans-serif;font-size:11px;color:#9a8f85;margin:0;';
        price.textContent = p.price || '';
        info.appendChild(name); info.appendChild(price);
        link.appendChild(thumb); link.appendChild(info);
        results.appendChild(link);
      });
    }
  })();

  /* ───────────────────────────────────────────────
     NEWSLETTER (footer form) — AJAX submit
     ─────────────────────────────────────────────── */
  (function initNewsletter() {
    var form = document.querySelector('.newsletter-form');
    if (!form || form.tagName !== 'FORM') return;
    form.addEventListener('submit', function (e) {
      // Let Shopify handle it natively; just show feedback after submit
      var input = form.querySelector('.newsletter-input');
      var success = form.parentElement.querySelector('.newsletter-success');
      if (!input || !input.value.trim() || input.value.indexOf('@') === -1) {
        e.preventDefault();
        input.style.borderBottomColor = '#8b2635';
        return;
      }
      if (success) {
        // Optimistic — Shopify will redirect back with ?customer_posted=true
        sessionStorage.setItem('sic_newsletter_submitted', '1');
      }
    });
    if (sessionStorage.getItem('sic_newsletter_submitted') ||
        window.location.search.indexOf('customer_posted=true') !== -1) {
      var success = document.querySelector('.newsletter-success');
      if (success) success.classList.add('visible');
      sessionStorage.removeItem('sic_newsletter_submitted');
    }
  })();

  /* ───────────────────────────────────────────────
     CART COUNT — refresh from /cart.js on page show
     ─────────────────────────────────────────────── */
  (function initCartCount() {
    var el = document.querySelector('.cart-count');
    if (!el) return;
    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          el.textContent = cart.item_count || '';
          el.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
        })
        .catch(function () {});
    }
    refresh();
    window.addEventListener('pageshow', refresh);
    document.addEventListener('cart:updated', refresh);
  })();

})();

/* =====================================================
   PRODUCT PAGE
   ===================================================== */
(function initProduct() {
  var form = document.querySelector('.product-form');
  if (!form) return;

  // SC modal in product.js handles variant selection + add-to-cart
  if (document.getElementById('scOverlay')) return;

  var productJsonEl = document.querySelector('[data-product-json]');
  if (!productJsonEl) return;
  var product;
  try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

  var variantInput = form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-product-price]');
  var stickyPriceEl = document.querySelector('[data-sticky-price]');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var ctaLabel = form.querySelector('[data-cta-label]');
  var optionButtons = form.querySelectorAll('.option-btn');

  function formatMoney(cents) {
    var sym = '€';
    if (window.Shopify && Shopify.currency) {
      var code = Shopify.currency.active;
      sym = ({ EUR: '€', USD: '$', CAD: 'CA$', GBP: '£' })[code] || code + ' ';
    }
    // cents is already in the active presentment currency — do NOT multiply by rate.
    return sym + Math.round(cents / 100);
  }

  function currentSelection() {
    var picks = [];
    product.options.forEach(function (_, idx) {
      var active = form.querySelector('.option-grid[data-option-index="' + idx + '"] .option-btn.active');
      picks.push(active ? active.dataset.optionValue : null);
    });
    return picks;
  }

  function findVariant(picks) {
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === picks[i]; });
    });
  }

  function updateAvailability(picks) {
    optionButtons.forEach(function (btn) {
      var idx = parseInt(btn.dataset.optionIndex, 10);
      var val = btn.dataset.optionValue;
      var testPicks = picks.slice();
      testPicks[idx] = val;
      var matching = product.variants.filter(function (v) {
        return v.options.every(function (ov, i) {
          if (testPicks[i] === null) return true;
          return ov === testPicks[i];
        });
      });
      var any = matching.some(function (v) { return v.available; });
      btn.classList.toggle('unavailable', !any);
    });
  }

  function update() {
    var picks = currentSelection();
    var variant = findVariant(picks);
    if (!variant) {
      addBtn.disabled = true;
      if (ctaLabel) ctaLabel.textContent = 'Unavailable';
      updateAvailability(picks);
      return;
    }
    variantInput.value = variant.id;
    var priceStr = (product.price_varies ? '' : '') + formatMoney(variant.price);
    if (variant.compare_at_price > variant.price) {
      priceStr = '<span class="compare-at">' + formatMoney(variant.compare_at_price) + '</span>' + priceStr;
    }
    if (priceEl) {
      priceEl.innerHTML = priceStr;
    }
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

    if (variant.available) {
      addBtn.disabled = false;
      if (ctaLabel) ctaLabel.textContent = (addBtn.getAttribute('data-cta-text') || 'Buy Now') + ' →';
    } else {
      addBtn.disabled = true;
      if (ctaLabel) ctaLabel.textContent = 'Sold out';
    }

    // Update URL with variant
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
    updateAvailability(picks);
  }

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.dataset.optionIndex;
      form.querySelectorAll('.option-grid[data-option-index="' + idx + '"] .option-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      update();
    });
  });

  // Save original CTA text
  if (ctaLabel) addBtn.setAttribute('data-cta-text', ctaLabel.textContent.trim().replace(' →', ''));

  // AJAX add to cart
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBtn.disabled) return;
    var formData = new FormData(form);
    var originalLabel = ctaLabel ? ctaLabel.textContent : '';
    if (ctaLabel) ctaLabel.textContent = 'Adding...';
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Add failed');
        if (ctaLabel) ctaLabel.textContent = '✓ Added';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          if (ctaLabel) ctaLabel.textContent = originalLabel;
          addBtn.disabled = false;
        }, 1800);
      })
      .catch(function (err) {
        if (ctaLabel) ctaLabel.textContent = 'Try again';
        addBtn.disabled = false;
        setTimeout(function () { if (ctaLabel) ctaLabel.textContent = originalLabel; }, 2000);
      });
  });

  // Initial availability pass
  updateAvailability(currentSelection());
})();

/* Product accordions */
(function initProductAccordions() {
  var heads = document.querySelectorAll('.accordion-head');
  if (!heads.length) return;
  heads.forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      var open = item.classList.toggle('open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();

/* Mouse drag-to-scroll + wheel-to-scroll on carousels and thumbnail strips.
   Auto-detects whether the element scrolls horizontally, vertically, or both.
   Mouse only — native touch scroll is left intact. */
(function initDragScroll() {
  var DRAG_THRESHOLD = 8; // px — below this we treat it as a plain click
  var selectors = [
    '#collections-scroll-wrap',
    '.reviews-track',
    '.shop-reviews-track-wrap',
    '.styled-grid',
    '.gallery-thumbs',
    '.drag-scroll'
  ];
  var els = document.querySelectorAll(selectors.join(','));
  if (!els.length) return;

  els.forEach(function (el) {
    var isDown = false, startX = 0, startY = 0, startScrollL = 0, startScrollT = 0;
    var moved = false, pointerId = null;
    el.style.cursor = el.style.cursor || 'grab';

    function axes() {
      return {
        h: el.scrollWidth > el.clientWidth + 1,
        v: el.scrollHeight > el.clientHeight + 1
      };
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      isDown = true;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      startScrollL = el.scrollLeft;
      startScrollT = el.scrollTop;
    });

    el.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!moved && Math.hypot(dx, dy) > DRAG_THRESHOLD) {
        moved = true;
        el.classList.add('is-dragging');
        try { el.setPointerCapture(pointerId); } catch (err) {}
      }
      if (!moved) return;
      var a = axes();
      if (a.h) el.scrollLeft = startScrollL - dx;
      if (a.v) el.scrollTop  = startScrollT - dy;
    });

    function end() {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-dragging');
      try { el.releasePointerCapture(pointerId); } catch (err) {}
      pointerId = null;
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);

    // Suppress the synthetic click that follows a real drag. Plain clicks
    // (movement below DRAG_THRESHOLD) fall through and navigate as expected.
    el.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    // Mouse wheel → scroll the element along its scrollable axis.
    // Horizontal carousels translate wheel-Y into scrollLeft; vertical strips
    // use native wheel (we only preventDefault when we actually consume it).
    el.addEventListener('wheel', function (e) {
      var a = axes();
      var delta = e.deltaY || e.deltaX;
      if (!delta) return;
      if (a.h && !a.v) {
        el.scrollLeft += delta;
        e.preventDefault();
      } else if (a.v) {
        var before = el.scrollTop;
        el.scrollTop += delta;
        if (el.scrollTop !== before) e.preventDefault();
      }
    }, { passive: false });

    // Prevent native image drag ghost during a drag-scroll
    el.addEventListener('dragstart', function (e) {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'A') e.preventDefault();
    });
  });
})();

/* Sticky buy bar */
(function initStickyBar() {
  var bar = document.getElementById('stickyBar');
  var productTitle = document.querySelector('.product-title');
  if (!bar || !productTitle) return;
  function check() {
    var rect = productTitle.getBoundingClientRect();
    bar.classList.toggle('visible', rect.bottom < 0);
  }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();
